import CompaniesService from "@/services/companies.service";

const state = {
  companies: [],
  mainIndex: -1
};
  
const getters = {
  items: state => {
    return state.companies;
  },
  mainCompany: state => {
    return state.companies[state.mainIndex];
  },
  getMainCompanyName: state=>{
      if(!state.companies[state.mainIndex]) return '';
      return state.companies[state.mainIndex].name;
  },
  getMainBaseCurrency: state=>{
      if(!state.companies[state.mainIndex]) return '';
      return state.companies[state.mainIndex].currency;
  }
};

const actions = {
  async getCompanies({
    commit,
  }) {
    let items = await CompaniesService.getCompanies();
    commit("setCompanies", items);
    return items;
  },
  async createCompany({
    commit
  }, data) {
    let response = await CompaniesService.create(data);
    commit("pushNewCompany", response);
    return response;
  },
  async updateCompany({
    commit
  }, {
    id, 
    data
  }) {
    let response = await CompaniesService.update(id, data);
    commit("updateExistingCompany", {
      id: id,
      company: response
    });
    return response;
  },
  async removeCompany({
    commit
  }, id) {
    await CompaniesService.delete(id);
    commit('removeExistingCompany', id)
    return;
  },
  async setMainCompany({
    commit
  }, id) {
    await CompaniesService.setMain(id);
    commit("changeMainCompany", id);
    return;
  },
};

const mutations = {
  setCompanies(state, payload) {
    state.companies = payload;
    state.mainIndex = state.companies.findIndex(item => item.main_company === 1);
  },
  pushNewCompany(state, payload) {
    state.companies.push(payload);
  },
  updateExistingCompany(state, {
    company,
    id
  }) {
    let companyIndex = state.companies.findIndex((item) => (item.id === id));
    if (companyIndex >= 0){
        //Todo fixed this part
        state.companies[companyIndex] = company;
    }
  
  },
  removeExistingCompany(state, id) {
    let companyIndex = state.companies.findIndex((item) => (item.id === id));
    if (companyIndex >= 0)
      state.companies.splice(companyIndex, 1)
  },
  changeMainCompany(state, id) {
    let companyIndex = state.companies.findIndex((item) => (item.id === id));
    
    if (companyIndex < 0)
      return;

    state.companies[state.mainIndex].main_company = 0;
    state.companies[companyIndex].main_company = 1;
    state.mainIndex = companyIndex;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
